import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCarousel, { EcoSectionCarouselItemProps } from 'eco-design/sections/eco-section-carousel';
import { useProductStore } from '../../../../ProductProvider';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA');
    const { t: s } = useLang('theProduct');
    const { pageStatus } = useProductStore();
    const { locale = 'us' } = getLocal();

    const IS_JP_SITE = ['jp'].includes(locale);

    const itemsA: EcoSectionCarouselItemProps[] = [
        {
            icon: '',
            title: t('item1_title'),
            desc: t('item1_desc'),
            isLink: true,
            link: '#SectionD',
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379215944/1p.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744596641990/1.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744770973739/A1-ss.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379215944/1p.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744596641990/1.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744770973739/A1-ss.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379215774/1-h5.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744784871259/1-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744784872260/1-ss-h5.jpg',
            dataLayer: {
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: s('SectionD.title'),
                button_name: t('item1_title'),
            },
        },
        {
            icon: '',
            title: t('item2_title'),
            desc: t('item2_desc'),
            isLink: true,
            link: IS_JP_SITE ? '#SectionG' : '#SectionE',
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/video/1744784435843/ot-2.mp4'
                : 'https://websiteoss.ecoflow.com/upload/image/1744596644344/2.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/video/1744784435843/ot-2.mp4'
                : 'https://websiteoss.ecoflow.com/upload/image/1744596644344/2.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/video/1744784435843/ot-2.mp4'
                : 'https://websiteoss.ecoflow.com/upload/image/1744596642192/2-h5.jpg',
            isVideo: IS_JP_SITE,
            autoPlay: IS_JP_SITE,
            loop: IS_JP_SITE,
            dataLayer: {
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: IS_JP_SITE ? s('SectionG.title') : s('SectionE.title'),
                button_name: t('item2_title'),
            },
        },
        {
            icon: '',
            title: t('item3_title'),
            desc: t('item3_desc'),
            isLink: true,
            link: IS_JP_SITE ? '#SectionE' : '#SectionG',
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379216717/3p.jpg'
                : 'https://websiteoss.ecoflow.com/upload/video/1744784435843/ot-2.mp4',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379216717/3p.jpg'
                : 'https://websiteoss.ecoflow.com/upload/video/1744784435843/ot-2.mp4',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379216539/3-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/video/1744784435843/ot-2.mp4',
            isVideo: !IS_JP_SITE,
            autoPlay: !IS_JP_SITE,
            loop: !IS_JP_SITE,
            dataLayer: {
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: IS_JP_SITE ? s('SectionE.title') : s('SectionG.title'),
                button_name: t('item3_title'),
            },
        },
        {
            icon: '',
            title: t('item4_title'),
            desc: t('item4_desc'),
            isLink: true,
            link: '#SectionI',
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379217188/4p.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744596642356/4.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379217188/4p.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744596642356/4.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379216924/4-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744596642548/4-h5.jpg',
            dataLayer: {
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: s('SectionI.title'),
                button_name: t('item4_title'),
            },
        },
        {
            icon: '',
            title: t('item5_title'),
            desc: t('item5_desc'),
            isLink: true,
            link: '#SectionJ',
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1747645549950/5p.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744596643952/5.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1747645549950/5p.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744596643952/5.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379217292/5-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744596644152/5-h5.jpg',
            dataLayer: {
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: s('SectionJ.title'),
                button_name: t('item5_title'),
            },
        },
    ];
    return (
        <div className={styles.comp} id="SectionA">
            <EcoSpace />
            <EcoSectionCarousel
                headerLayout="header-top"
                pagination
                title={t('title')}
                items={itemsA}
                swiperAutoPlay
                autoplay={{
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                    animationNavigationRight: true,
                    viewport: {
                        open: true,
                    },
                }}
            />
            {pageStatus === 'statusB' && <EcoSpace />}
            {locale === 'jp' && <EcoSpace />}
        </div>
    );
}
